import React from 'react'
import CustomersList from './customers'
import CustomerListIndividual from './customerIndividual'

function CustomerMain() {
  const role = JSON.parse((localStorage.getItem('kt-auth-react-v') as any) || {})?.data?.role?.role_id

  // console.log("role", role)
  return <>{role === 1 || role === 2 ? <CustomersList /> : <CustomerListIndividual />}</>
}

export default CustomerMain
